import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { PaymentTypes, UserTypes } from "../../../_models";
import {
  AbstractControl,
  AsyncValidatorFn,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import * as _ from "lodash";
import isFuture from "date-fns/isFuture";
import differenceInYears from "date-fns/differenceInYears";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "depositmodal",
  templateUrl: "deposit-modal.component.html",
  styleUrls: ["./deposit-modal.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class DepositModalComponent {
  @Input() event?: any;
  @Input() child?: any;
  @Input() paymentItem?: any;
  @Input() base: any;
  @Output() actionCompleted?: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild("moveToOpenReceiptsDialog") moveToOpenReceiptsDialogTemp;
  loading: boolean = false;
  successMessage: string;
  errorMessage: string;
  formGroup: FormGroup;
  modalReference: any;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    private modalService: NgbModal
  ) {}

  showMoveToOpenReceiptsModal() {
    const options: NgbModalOptions = {
      windowClass: "modal-direct-open-receipts",
      backdrop: "static",
    };
    this.modalReference = this.modalService.open(
      this.moveToOpenReceiptsDialogTemp,
      options
    );
  }

  makeDeposit(modalContent: any, child?: any) {
    this.errorMessage = undefined;
    this.successMessage = undefined;
    if (child) {
      this.event["childrenForThisDeposit"] = [child];
    }

    const hasNotCompletedDepositsParam = this.hasNotCompletedDeposits(
      this.event["childrenForThisDeposit"]
        ? this.event["childrenForThisDeposit"]
        : this.event["children"]
    );
    if (
      hasNotCompletedDepositsParam &&
      this.base.user.type < UserTypes.TYPE_RAKAZ_MAHOZ
    ) {
      this.alertService.error(
        this.base.messages.open_receipts_deposit_not_allowed
      );
    } else {
      const options: NgbModalOptions = {
        windowClass: "modal-deposit-opened",
        backdrop: "static",
      };
      this.modalReference = this.modalService.open(modalContent, options);

      this.formGroup = new FormGroup({
        depositNumber: new FormControl(null, [Validators.required]),
        depositDate: new FormControl(null, [
          this.validateDate,
          this.validateFutureDate(this.event, PaymentTypes.PAYMENT_TYPE_CASH),
        ]),
        depositAmount: new FormControl(null, [Validators.required]),
      });
    }
  }

  validateDate(c: FormControl) {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    const dateString = c.value;
    if (!dateString || !dateString.match(regEx))
      return {
        validateDate: "INVALID_DATE",
      }; // Invalid format
    const d = new Date(dateString);
    if (Number.isNaN(d.getTime())) {
      return {
        validateDate: "INVALID_DATE",
      };
    } // Invalid date
    if (differenceInYears(Date.now(), d) > 4) {
      return {
        farPastDate: "open_receipts_deposit_date_cannot_be_a_far_past_date",
      };
    }
    return d.toISOString().slice(0, 10) === dateString
      ? null
      : {
          validateDate: {
            validateDate: "INVALID_DATE",
          },
        };
  }

  validateFutureDate(event: any, paymentTypeCash: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const dateString = control.value;
      const d = new Date(dateString);
      if (isFuture(d) && event.paymentType === paymentTypeCash) {
        if (event) {
          return {
            FutureDate: "open_receipts_deposit_date_cannot_be_a_future_date",
            valid: false,
          };
        }
        return null;
      }
    };
  }

  hasNotCompletedDeposits(childrenData: any[]) {
    let hasAmountLeftArr = _.filter(
      childrenData,
      ({ amountLeftToDeposit }) => amountLeftToDeposit > 0
    );
    return (
      hasAmountLeftArr && hasAmountLeftArr.length && hasAmountLeftArr.length > 0
    );
  }

  submitDeposit() {
    if (!this.loading) {
      this.errorMessage = undefined;
      let thisEvent = Object.assign({}, this.event);
      if (this.event["childrenForThisDeposit"]) {
        thisEvent["children"] = this.event["childrenForThisDeposit"];
        this.event["childrenForThisDeposit"] = undefined;
      }

      let totalAmountToDeposit = 0;
      if (!thisEvent["children"][0].isCash)
        totalAmountToDeposit = this.event.totalAmount;
      else {
        thisEvent["children"].forEach((ch) => {
          totalAmountToDeposit +=
            ch.amountLeftToDeposit > 0 ? ch.amountLeftToDeposit : ch.finalPrice;
        });
      }
      if (
        thisEvent["children"][0].isCash &&
        totalAmountToDeposit < this.formGroup.getRawValue()["depositAmount"]
      ) {
        this.errorMessage =
          this.base.messages["open_receipts_deposit_amount_error"];
      } else if (
        !thisEvent["children"][0].isCash &&
        totalAmountToDeposit !== this.formGroup.getRawValue()["depositAmount"]
      ) {
        this.errorMessage =
          this.base.messages["open_receipts_deposit_amount_cheque_error"];
      } else {
        const postData = _.merge(thisEvent, this.formGroup.getRawValue());
        if (postData.children && postData.children.length) {
          let amountLeftToDeposit = postData.depositAmount;
          const children: any = [];
          let go: boolean = true;
          postData.children.forEach((child) => {
            const priceToConsider = child.amountLeftToDeposit
              ? child.amountLeftToDeposit
              : child.finalPrice;
            if (go && priceToConsider >= amountLeftToDeposit) {
              child.newAmountLeftToDeposit =
                priceToConsider - amountLeftToDeposit;
              children.push(child);
              go = false;
            } else if (go && priceToConsider < amountLeftToDeposit) {
              child.newAmountLeftToDeposit = 0;
              children.push(child);
              amountLeftToDeposit = amountLeftToDeposit - priceToConsider;
            }
          });
          postData.children = children;
        }
        this.loading = true;
        this.dataService.postEntity("save-deposit", postData).subscribe(
          (data) => {
            this.loading = false;
            const message =
              totalAmountToDeposit === postData.depositAmount
                ? this.base.messages["open_receipts_deposit_success"]
                : this.base.messages["open_receipts_deposit_success_partly"];
            this.successMessage = message
              ? message.replace("$1$", data.depositNumber)
              : "נקלט בהצלחה!!!";
          },
          (error) => {
            this.loading = false;
            const body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.base.messages[body.statusText]
                  ? this.base.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
          }
        );
      }
    }
  }

  depositCompleted() {
    this.modalReference.close();
    if (this.actionCompleted) {
      this.actionCompleted.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/teshlumon/open-receipts/deposit-modal.component.ts